import React, { memo, useCallback } from 'react';
import { Avatar, Button, Icon, Typography } from '@ann/web-components';
import { WIDGET_LIBRARY_COPY } from '../../../../constants/dashboardBuilderCopy';
import {
  AvatarIconOverlay,
  AvatarSlot,
  Container,
  Footer,
  SelectedStatus,
  TextBlock,
  TitleWrapper,
  TopRow,
} from './WidgetListItem.styled';

const WidgetListItem = ({ widget, isSelected, onToggle, widgetId }) => {
  const handleToggle = useCallback(
    (e) => {
      e.stopPropagation();
      onToggle(widgetId);
    },
    [onToggle, widgetId]
  );

  return (
    <Container $selected={isSelected} onClick={handleToggle}>
      <TopRow>
        <AvatarSlot>
          <Avatar
            size="sm"
            src={widget.previewImage || undefined}
            alt={widget.name || 'Widget'}
          />
          {!widget.previewImage && (
            <AvatarIconOverlay $selected={isSelected}>
              <Icon name={widget.icon} size="small" />
            </AvatarIconOverlay>
          )}
        </AvatarSlot>
        <TitleWrapper>
          <Typography category="label" size="small" weight="bold">
            {widget.name}
          </Typography>
        </TitleWrapper>
      </TopRow>
      {isSelected && (
        <SelectedStatus>
          <Icon name="check" size="small" />
          <Typography category="label" size="small" weight="bold">
            {WIDGET_LIBRARY_COPY.selectedBadgeLabel}
          </Typography>
        </SelectedStatus>
      )}
      <TextBlock>
        <Typography category="body" size="small" weight="regular" color="secondary">
          {widget.description}
        </Typography>
      </TextBlock>
      <Footer>
        <Button
          type="secondary"
          size="small"
          iconLeft={isSelected ? 'delete2' : 'plus'}
          label={
            isSelected
              ? WIDGET_LIBRARY_COPY.listItemRemoveButton
              : WIDGET_LIBRARY_COPY.listItemAddButton
          }
          onClick={handleToggle}
          htmlType="button"
        />
      </Footer>
    </Container>
  );
};

export default memo(WidgetListItem);
